export default function LoadingAi({
  color = '#FF9606',
  width = '54',
  height = '26',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
      width={width}
      height={height}
      style={{ shapeRendering: 'auto', display: 'block', background: 'transparent' }}
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g>
        <circle fill={color} r='10' cy='50' cx='84'>
          <animate
            begin='0s'
            keySplines='0 0.5 0.5 1'
            values='10;0'
            keyTimes='0;1'
            calcMode='spline'
            dur='0.5s'
            repeatCount='indefinite'
            attributeName='r'
          ></animate>
          <animate
            begin='0s'
            values='#ffffff;#ffffff;#ffffff;#ffffff;#ffffff'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='discrete'
            dur='2s'
            repeatCount='indefinite'
            attributeName='fill'
          ></animate>
        </circle>
        <circle fill={color} r='10' cy='50' cx='16'>
          <animate
            begin='0s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='0;0;10;10;10'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='r'
          ></animate>
          <animate
            begin='0s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='16;16;16;50;84'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='cx'
          ></animate>
        </circle>
        <circle fill={color} r='10' cy='50' cx='50'>
          <animate
            begin='-0.5s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='0;0;10;10;10'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='r'
          ></animate>
          <animate
            begin='-0.5s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='16;16;16;50;84'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='cx'
          ></animate>
        </circle>
        <circle fill={color} r='10' cy='50' cx='84'>
          <animate
            begin='-1s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='0;0;10;10;10'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='r'
          ></animate>
          <animate
            begin='-1s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='16;16;16;50;84'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='cx'
          ></animate>
        </circle>
        <circle fill={color} r='10' cy='50' cx='16'>
          <animate
            begin='-1.5s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='0;0;10;10;10'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='r'
          ></animate>
          <animate
            begin='-1.5s'
            keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
            values='16;16;16;50;84'
            keyTimes='0;0.25;0.5;0.75;1'
            calcMode='spline'
            dur='2s'
            repeatCount='indefinite'
            attributeName='cx'
          ></animate>
        </circle>
        <g></g>
      </g>
    </svg>
  );
}
